/**
 * Design Tokens for Repli Sandbox Avenew Theme
 * 
 * Extends the base american-landmark-arte theme tokens with Repli Sandbox Avenew branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-american-landmark-arte/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Repli Sandbox Avenew brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
    // Repli Sandbox Avenew brand colors - customize these
    // primary: '#your-primary-color',
    // secondary: '#your-secondary-color',
    // accent: '#your-accent-color',
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
    // Repli Sandbox Avenew typography - customize these
    // heading: '"Your Heading Font", serif',
    // body: '"Your Body Font", sans-serif',
  },
};

export default tokens;
